import { Timestamp } from 'firebase/firestore';

export enum FieldType {
  Information = 'information',
  Small = 'small',
  Credit = 'credit',
  Description = 'description',
  Text = 'text',
  MultiLineText = 'multi_line_text',
  Date = 'date',
  Number = 'number',
  Checkbox = 'checkbox',
  Range = 'range',
  Today = 'today',
  DateOfBirth = 'date_of_birth',
  Assessment = 'assessment',
  InvAssessment = 'inv_assessment',
  NzAssessment = 'nz_assessment',
  Assessment10 = 'assessment10',
  InvAssessment10 = 'inv_assessment10',
  NzAssessment10 = 'nz_assessment10',
  Weight = 'weight',
  Size = 'size',
  WaistSize = 'waist_size',
  HipSize = 'hip_size',
  ThighSize = 'thigh_size',
  FormWeight = 'form_weight',
  ArmSize = 'arm_size',
  FatMass = 'fat_mass',
  MuscularMass = 'muscular_mass',
  Comment = 'comment',
  Prompt = 'prompt',
  Prompt1 = 'prompt1',
  Prompt2 = 'prompt2',
  Prompt3 = 'prompt3',
  Prompt4 = 'prompt4',
  Prompt5 = 'prompt5',
  Prompt6 = 'prompt6',
  Prompt7 = 'prompt7',
  Prompt8 = 'prompt8',
  Prompt9 = 'prompt9',
  Prompt10 = 'prompt10',
  Prompt11 = 'prompt11',
  Prompt12 = 'prompt12',
  Prompt13 = 'prompt13',
  Prompt14 = 'prompt14',
  Prompt15 = 'prompt15',
  Prompt16 = 'prompt16',
  Prompt17 = 'prompt17',
  Prompt18 = 'prompt18',
  Prompt19 = 'prompt19',
  Prompt20 = 'prompt20',
  Prompt21 = 'prompt21',
  Prompt22 = 'prompt22',
}

export class FieldTool {
  static valueToSchema(fieldType: FieldType, value: unknown) {
    switch (fieldType) {
      case FieldType.Information:
      case FieldType.Small:
      case FieldType.Credit:
      case FieldType.Description:
        return null;
      case FieldType.MultiLineText:
      case FieldType.Text:
        return value as string;
      case FieldType.Checkbox:
        return value as boolean;
      case FieldType.Date:
      case FieldType.DateOfBirth:
      case FieldType.Today:
        return value instanceof Date ? Timestamp.fromDate(value) : null;
      case FieldType.Number:
      case FieldType.ArmSize:
      case FieldType.FatMass:
      case FieldType.FormWeight:
      case FieldType.HipSize:
      case FieldType.MuscularMass:
      case FieldType.Size:
      case FieldType.ThighSize:
      case FieldType.WaistSize:
      case FieldType.Weight:
      case FieldType.Range:
      case FieldType.Assessment:
        return Number(value);
      default:
        return value ?? null;
    }
  }

  static valueFromSchema(fieldType: FieldType, schema: unknown) {
    switch (fieldType) {
      case FieldType.Information:
      case FieldType.Small:
      case FieldType.Credit:
      case FieldType.Description:
        return null;
      case FieldType.MultiLineText:
      case FieldType.Text:
        return schema as string;
      case FieldType.Checkbox:
        return schema as boolean;
      case FieldType.Date:
      case FieldType.DateOfBirth:
      case FieldType.Today:
        return schema instanceof Timestamp ? schema.toDate() : undefined;
      case FieldType.Number:
      case FieldType.ArmSize:
      case FieldType.FatMass:
      case FieldType.FormWeight:
      case FieldType.HipSize:
      case FieldType.MuscularMass:
      case FieldType.Size:
      case FieldType.ThighSize:
      case FieldType.WaistSize:
      case FieldType.Weight:
      case FieldType.Range:
      case FieldType.Assessment:
        return Number(schema);
      default:
        return schema ?? null;
    }
  }
}
